import type { FeedbackTelemetry } from '@paladin-monorepo/common';

export function buildClientFeedbackTelemetry(): FeedbackTelemetry {
  return {
    userAgent: navigator.userAgent,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    screenColorDepth: screen.colorDepth,
    screenPixelRatio: window.devicePixelRatio,
    screenResolution: `${screen.width}x${screen.height}`,
    screenOrientation: screen.orientation?.type,
    screenLanguage: navigator.language,
    screenColorScheme: window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light',
    url: window.location.href,
    referrer: document.referrer,
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    origin: window.location.origin,
    protocol: window.location.protocol,
  };
}
